<template>
  <div>
     <div class="centerx">
      <vs-popup
        class="holamundo"
        v-bind:title="'Ajuda - Cadastro da mão de obra'"
        :active.sync="popupActivo"
      >
        <div v-html="textoAjuda"></div>
      </vs-popup>
    </div>
   
    <div
      class="card card-header list-group-item list-group-item-action active mb-3"
    >
      <h4 class="mb-0">Cadastro de mãos de obras</h4>
       <div
        class="badge bagde-default"
        @click="popupActivo = true"
        style="position: absolute; top: 17px; right: 15px"
      >
        Ajuda <i class="fa fa-question-circle"></i>
      </div>
   </div>
    <div class="card">
      <form style="padding: 15px" autocomplete="off">
        <h4 class="mb-3">Dados da mão de obra</h4>
        <div class="form-row">
          <div class="form-group col-md-8">
            <label for="_form-nome">Nome</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.nome"
              id="_form-nome"
              required
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-periodo">Regime de contratação</label>
              <vs-select
                id="_form-periodo"
                placeholder="Selecione o regime"
                class="selectExample"
                label-placeholder="Autocomplete"
                autocomplete
                v-model="cadastro.regimeId"
                style="width:100%"
                >
                <vs-select-item :key="index" :value="item.regimeId" :text="item.titulo" v-for="(item,index) in regimes" />
              </vs-select>    

              <div class="form-group mt-2" v-if="cadastro.regimeId == 0">
                <label>Outro</label>
                <input type="text" name="outroRegime" v-model="outroRegime" class="form-control">
              </div>           
          </div>

          <div class="form-group col-md-6">
            <label for="_form-nome">CPF</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.cpf"
              id="_form-nome"
              required
              maxlength="11"
              v-mask="'###########'"
              @change="validaCPF"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-jornadaTrabalho">Jornada de trabalho</label>
            <vue-numeric
              type="text"
              class="form-control"
              v-model="cadastro.jornadaTrabalho"
              id="_form-jornadaTrabalho"
              required
            />
          </div>
          <div class="form-group col-md-3">
            <label for="_form-salario">Salário</label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.salario"
              id="_form-salario"
              required
              currency="R$"
            />
          </div>
          <div class="form-group col-md-3">
            <label for="_form-decimoTerceiro">Décimo terceiro</label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.decimoTerceiro"
              id="_form-decimoTerceiro"
              required
              currency="R$"
            />
          </div>
        </div>
        <div style="display: flex; jusify-content: flex-end">
          <button class="btn btn-primary ml-auto" @click.prevent="fnCadastra">
            Salvar
          </button>
        </div>
      </form>
      <div style="padding: 15px">
        <vs-table :data="content">
          <template slot="header">
            <h3>Registros</h3>
          </template>
          <template slot="thead">
            <vs-th :style="'width:' + iconArea + 'px'"> Ações </vs-th>
            <vs-th> Nome </vs-th>
            <vs-th style="width: 150px"> CPF </vs-th>
            <vs-th style="width: 150px"> Salário </vs-th>
            <vs-th style="width: 150px"> Décimo terceiro </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :state="tr.aprovada ? 'success' : null"
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data"
            >
              <vs-td v-if="!tr.aprovada">
                <a
                  class="icone-editar"
                  data-editar
                  @click="fnEditar(indextr)"
                  title="Editar"
                >
                  <i class="i-circled i-small i-light icon-line-edit"></i>
                </a>

                <a
                  class="icone-editar"
                  data-editar
                  title="Funções"
                  @click="fnFuncoes(tr.etapaId)"
                >
                  <i class="i-circled i-small i-light icon-briefcase1"></i>
                </a>
                <a
                  class="icone-editar"
                  data-editar
                  title="Benefícios"
                  @click="fnBeneficios(tr.etapaId)"
                >
                  <i class="i-circled i-small i-light icon-credit-cards"></i>
                </a>
                <a
                  class="icone-editar"
                  data-deletar
                  @click="fnDeletar(tr.etapaId)"
                  title="Deletar"
                >
                  <i class="i-circled i-small i-light icon-trash"></i>
                </a>
              </vs-td>
              <vs-td :data="tr.aprovada" v-else>
                <div style="display: flex; align-items: center">
                  <i class="i-circled i-small i-light icon-flag-checkered1"></i>
                  Aprovado
                </div>
              </vs-td>
              <vs-td :data="tr.nome">
                {{ tr.nome }}
              </vs-td>

              <vs-td :data="tr.cpf">
                {{ tr.cpf }}
              </vs-td>
              <vs-td :data="tr.salario">
                R$ {{ formataPrice(tr.salario) }}
              </vs-td>
              <vs-td :data="tr.salario">
                R$ {{ formataPrice(tr.decimoTerceiro) }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getSuccess, formatPrice, clientKey, validarCPF } from "../../../global/utils";

export default {
  data() {
    return {
      content: [],
      cadastro: {},
      regimes: {},
      incluindo: false,
      iconArea: 86 * 2,
      titulo: "",
      tipo: "",
      servico: null,
      textoAjuda: null,
      popupActivo: false,
      outroRegime: "",
      cadastroid: null,
    };
  },
  mounted() {
    this.fnGetContratacao();
    this.fnGetRegimes();
  },
  methods: {
    async fnGetRegimes() {
      await this.$http
        .get("listaregimescontratacao/api/")
        .then((res) => {
          this.regimes = res.data;
          this.regimes.push({regimeId:0, titulo: "Outros"})
        })
        .catch(() => {});
      await this.$http
        .get(`contratacao/lista/${this.$route.params.codigoContrato}`)
        .then((res) => {
          this.servico = res.data.servicos;
          this.textoAjuda = this.servico.textoAjuda05;
        });
    },validaCPF(){
      console.log(this.cadastro.cpf);
      var cpfValido = validarCPF(this.cadastro.cpf);
      if(!cpfValido){
         this.$toasted.global.defaultInfo({
            msg: "CPF inválido",
          });
          this.cadastro.cpf = null;
      }
    },
    formataPrice(val) {
      return formatPrice(val);
    },
    async fnCadastra(e) {
      e.preventDefault();
      const metodo = this.cadastro.etapaId ? "put" : "post";
      this.cadastro.tsAlteracao = this.cadastro.etapaId
        ? this.$moment().format()
        : null;
      const completaUrl = this.cadastro.etapaId
        ? "/" + this.cadastro.etapaId
        : "";
      let headers = {
        'outroRegime': this.outroRegime,
      };
      await this.$http[metodo]("/etapa_05" + completaUrl + "?outroRegime=" + this.outroRegime, this.cadastro,{headers: headers})
        .then((res) => {
          if (metodo == "post") {
            this.content.push(res.data);
            this.$router.push(`${this.$route.params.codigoContrato}/funcoes/${res.data.etapaId}`);
          }
          getSuccess();
          this.cadastro = {
            contratacaoId: this.cadastroid,
          };
        })
        .catch(() => {});
    },

    async fnGetContratacao() {
      await this.$http
        .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_05`)
        .then((res) => {
          console.log(res.data.contratacaoId);
          this.cadastro.contratacaoId = res.data.contratacaoId;
          this.cadastroid = res.data.contratacaoId;
          console.log(res.data.contratacoesEVO05);
          console.log(res.data.contratacoesEVO05 != null);
          if (res.data.contratacoesEVO05 != null) {
            var toString = JSON.stringify(res.data.contratacoesEVO05);
            var toJson = JSON.parse(toString);
            for (var i = 0; i < toJson.length; i++) {
              this.content.push(toJson[i]);
            }
          }
        })
        .catch(() => {});
    },
    fnCancela() {
      this.incluindo = false;
      this.titulo = "";
      this.tipo = "";
    },
    fnEdicao(val) {
      if (val == "Incluindo") {
        this.incluindo = true;
        this.titulo = "Incluindo novo registro";
        this.tipo = "Inclusão";
      }
    },
    fnEditar(i) {
      this.cadastro = this.content[i];
    },
    fnConcat(val) {
      var item = this.regimes.filter((administracoes) => {
        return administracoes.regimeId == val;
      });
      var toString = JSON.stringify(item);
      var toJson = JSON.parse(toString);
      return toJson[0].titulo;
    },
    fnFuncoes(val) {
      this.$router.push({
        path: `/areacliente/contrato/etapa5/${this.$route.params.codigoContrato}/funcoes/${val}`,
      });
    },
    fnBeneficios(val) {
      this.$router.push({
        path: `/areacliente/contrato/etapa5/${this.$route.params.codigoContrato}/beneficios/${val}`,
      });
    },
    convertToken(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },
    async fnDeletar(val) {
      var token = localStorage.getItem(clientKey);
      var dataToken = this.convertToken(token);
      await this.$http
        .delete(`/etapa_05/${val}/${dataToken.ClienteId}`)
        .then(() => {
          let i = this.content.map((item) => item.etapaId).indexOf(val);
          this.content.splice(i, 1);
          getSuccess();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
.expand-user {
  width: 100%;
}
</style>